import React, { useState } from "react";

export default function RoleSelector({
  roles = [],
  onChange
}) {

  const [roleInput, setRoleInput] =
    useState("");

  const addRole = () => {

    const value = roleInput.trim();

    if (!value) {
      return;
    }

    if (roles.includes(value)) {
      return;
    }

    onChange(
      [...roles, value]
    );

    setRoleInput("");
  };

  const removeRole = (role) => {

    onChange(
      roles.filter(
        r => r !== role
      )
    );
  };

  return (

   <div className="form-section">

        <h3 className="section-title">
        Roles
        </h3>

      <div className="inline-group">

        <input
          className="form-input"
          placeholder="ADMIN"
          value={roleInput}
          onChange={(e) =>
            setRoleInput(
              e.target.value
            )
          }
        />

        <button
          type="button"
          className="btn btn-secondary"
          onClick={addRole}
        >
          Add
        </button>

      </div>

      <div className="role-chip-container">

        {roles.map(role => (

          <div
            key={role}
            className="role-chip"
          >

            <span>

              {role}

            </span>

            <button
              type="button"
              className="chip-remove"
              onClick={() =>
                removeRole(role)
              }
            >
              ×
            </button>

          </div>

        ))}

      </div>

    </div>
  );
}